import { render, staticRenderFns } from "./AlipayOrderFeedback.vue?vue&type=template&id=64eb11b3&scoped=true&"
import script from "./AlipayOrderFeedback.vue?vue&type=script&lang=js&"
export * from "./AlipayOrderFeedback.vue?vue&type=script&lang=js&"
import style0 from "./AlipayOrderFeedback.vue?vue&type=style&index=0&id=64eb11b3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64eb11b3",
  null
  
)

component.options.__file = "AlipayOrderFeedback.vue"
export default component.exports